import { z } from 'zod';
import { password, PasswordValidationT } from './schema-methods';

export interface ChangePasswordT extends PasswordValidationT {
  passwordsDontMatch: string;
}

export const changePasswordSchema = (t: ChangePasswordT) =>
  z
    .object({
      password_current: z.string().min(1, t.required),
      password_new: password(t),
      password_confirm: z.string().min(1, t.required),
    })
    .refine((d) => d.password_confirm === d.password_new, { message: t.passwordsDontMatch });
